import { useRef, useEffect, useMemo } from "react";
export default function useCallbackRef(callback) {
    const ref = useRef(callback);
    useEffect(() => {
        ref.current = callback;
    });
    // See https://github.com/facebook/react/issues/19240#issuecomment-652945246
    return useMemo(() => ((...args) => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args); }), []);
}
